/* eslint-disable import/prefer-default-export */
import api from "./axios";

export async function getRef(deviceId) {
  const response = await api.get(`/refs/${deviceId}`);
  return response;
}

export async function postRef(ref) {
  const response = await api.post("/refs", ref);
  return response;
}

export async function deleteRef(refId) {
  const response = await api.delete(`/refs/${refId}`);
  return response;
}

export async function putRef(ref, refId) {
  const response = await api.put(`/refs/${refId}`, ref);
  return response;
}
